import { render } from "./register-page.vue?vue&type=template&id=de1824de&ts=true"
import script from "./register-page.ts?vue&type=script&lang=ts"
export * from "./register-page.ts?vue&type=script&lang=ts"

import "./register-page.vue?vue&type=style&index=0&id=de1824de&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__